import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  createNewSlide: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/create/`,
  },
  updateSlideById: {
    method: 'PUT',
    url: `${configs.baseUrl}/api/slide/update/{slideId}`,
  },
  patchSlideById: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/slide/{slideId}`,
  },
  updateNextSlideById: {
    method: 'PUT',
    url: `${configs.baseUrl}/api/presentation/update-next-slide/{slideId}`,
  },
  slideScaleQuestionById: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/scale-result/{slideId}`,
  },
  patchSlides: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/slide/`,
  },
  duplicateSlides: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/duplicate-slides/`,
  },
  clearSlides: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/clear-slides/`,
  },
  spinTheWheel: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/spinner-wheel/{slideId}/spin`,
  },
  stopTheWheel: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/spinner-wheel/{slideId}/stop`,
  },
  updateTheWheel: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/spinner-wheel/{slideId}/update`,
  },
  matchPairsResult: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/{slideId}/get-result/`,
  },
  duplicateOtherPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/duplicate-other-presentation/`,
  },
  getPublicSlideTemplates: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/public-templates`,
  },
  publishContentSlideTemplate: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/public-templates`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createNewSlide = (params) => {
  return resource.createNewSlide(params)
}

const updateSlideById = (slideId, params) => {
  return resource.updateSlideById({ slideId }, params)
}

const slideScaleQuestionById = (slideId, params) => {
  return resource.slideScaleQuestionById({ slideId }, params)
}

const patchSlideById = (slideId, params) => {
  return resource.patchSlideById({ slideId }, params)
}

const updateNextSlideById = (slideId, params) => {
  return resource.updateNextSlideById({ slideId }, params)
}

const updateSlides = async (params) => {
  return resource.patchSlides(params)
}

const duplicateSlides = async (params) => {
  return resource.duplicateSlides(params)
}

const clearSlides = async (params) => {
  return resource.clearSlides(params)
}

const spinTheWheel = async (slideId, params) => {
  return resource.spinTheWheel({ slideId }, params)
}

const stopTheWheel = async (slideId, params) => {
  return resource.stopTheWheel({ slideId }, params)
}

const updateTheWheel = async (slideId, params) => {
  return resource.updateTheWheel({ slideId }, params)
}

const matchPairsResult = (slideId, params) => {
  return resource.matchPairsResult({ slideId }, params)
}

const duplicateOtherPresentation = (params) => {
  return resource.duplicateOtherPresentation(params)
}

const getPublicSlideTemplates = async () => {
  const res = await resource.getPublicSlideTemplates()
  return res.body
}

const publishContentSlideTemplate = async (params) => {
  const res = await resource.publishContentSlideTemplate(params)
  return res.body
}

export default {
  initResource,
  createNewSlide,
  patchSlideById,
  updateNextSlideById,
  updateSlideById,
  slideScaleQuestionById,
  updateSlides,
  duplicateSlides,
  clearSlides,
  spinTheWheel,
  stopTheWheel,
  updateTheWheel,
  matchPairsResult,
  duplicateOtherPresentation,
  getPublicSlideTemplates,
  publishContentSlideTemplate,
}
